import * as THREE from 'three'

export default function createLights({ scene })
{
  const directionalLight = new THREE.DirectionalLight('#ffffff', 4)
  directionalLight.position.set(6.25, 3, 4)
  directionalLight.castShadow = true
  directionalLight.shadow.mapSize.set(1024, 1024)
  directionalLight.shadow.camera.near = 0.1
  directionalLight.shadow.camera.far = 30
  directionalLight.shadow.normalBias = 0.05
  directionalLight.shadow.camera.top = 8
  directionalLight.shadow.camera.right = 8
  directionalLight.shadow.camera.bottom = -8
  directionalLight.shadow.camera.left = -8

  scene.add(directionalLight)

  return { directionalLight }
}
